import React from "react";
import checkMark from "../../images/Svg/CheckMark.svg";
import Round from "../../images/Svg/Round.svg";
import BlackCheck from "../../images/Svg/BlackCheck.svg";
import CheckRound from "../../images/Svg/CheckRound.svg";
import { Fade } from "react-reveal";

const AllTweetComponents = ({
  title,
  allTweet,
  handleAllTweet,
  setAllTweetQRetweet,
  setAllTweetRetweet,
  allTweetRetweet,
  allTweetQRetweet,
  id,
}) => {
  return (
    <Fade cascade duration={1000}>
      <div>
        <div
          className={`${
            allTweet
              ? "bg-[#F6F7FF] border-[#5463FF] border-[2px]"
              : "bg-[#FFFFFF] border border-[#E1E1E1]"
          } ${
            id == "twitter"
              ? "min-h-[266px] sm:min-h-[266px] md:min-h-[460px]"
              : "h-[88px] flex item-center"
          } card mx-auto cursor-pointer up_hover`}
        >
          <div
            onClick={handleAllTweet}
            className="flex items-center cursor-pointer"
          >
            <img className="mx-3" src={allTweet ? CheckRound : Round} alt="" />
            <h5>{title}</h5>
          </div>

          {id === "twitter" && (
            <>
              <div className="border-b border-[#E1E1E1] mt-[8px]"></div>
              <div
                className="flex_card_style cursor-pointer  pt-[40px]"
                onClick={() => setAllTweetRetweet(!allTweetRetweet)}
              >
                <img src={allTweetRetweet ? checkMark : BlackCheck} alt="" />
                <p className="text-[16px] text-[#161616] ml-[16px]">
                  Including Retweets
                </p>
              </div>
              <div
                onClick={() => setAllTweetQRetweet(!allTweetQRetweet)}
                className="flex_card_style cursor-pointer pt-[25px]"
              >
                {" "}
                <img src={allTweetQRetweet ? checkMark : BlackCheck} alt="" />
                <p className="text-[16px] text-[#161616] cursor-pointer ml-[16px]">
                  Including Quote tweets
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </Fade>
  );
};

export default AllTweetComponents;
